import * as React from 'react'
import { InviteMainConnected } from './InviteMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_INVITE_A_ID } from 'mockState'

export const InviteMainExamples = () => {
  return (
    <div className="InviteMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <InviteMainConnected inviteId={MOCK_INVITE_A_ID} />
      </Provider>
    </div>
  )
}
